import CaseScreen from './CaseScreen';

export default CaseScreen;
